import { gql } from "@apollo/client";

export const uploadFileMutation = gql`
  mutation addProfilePicture($picture: Upload!) {
    addProfilePicture(picture: $picture)
  }
`;
